import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import {
  GridFooter,
  GridFooterContainer,
  GridSelectionModel,
  gridVisibleColumnDefinitionsSelector,
  gridVisibleSortedRowIdsSelector,
  useGridApiRef
} from '@mui/x-data-grid-pro';
import React, { useEffect, useRef, useState } from 'react';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { archLevel } from 'src/data/config';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import {
  useDeleteOthersProtocolQALogMutation,
  useDeleteProtocolQALogMutation,
  useUpdateOtherResponseProtocolQALogMutation,
  useUpdateOthersProtocolQALogMutation,
  useUpdateProtocolQALogMutation,
  useUpdateResponseProtocolQALogMutation,
  useUpdateStatusProtocolQALogMutation
} from 'src/services/protocolQALogs';
import { useAppSelector } from 'src/store';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store/hooks';
import '../studylogStyles.scss';
import AddandUpdateProtocolQA from './AddandUpdateProtocolQA';
import DataGridProtocolQALog from './DataGridProtocolQALog';
import { useProtocolQALog } from './useProtocolQA';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';

export default function ProtocolQA({ setStudyLogOpen, setProtocolQAOn }: any) {
  const handelBack = () => {
    setProtocolQAOn(false);
    setStudyLogOpen(true);
  };
  const apiRef = useGridApiRef();
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const [currentProtocolQALevel, setProtocolQALevel] = React.useState<string>('');
  const {
    protocolQALogData,
    protocolQALogDataError,
    protocolQALogDataIsError,
    protocolQALogDataIsLoading,
    getProtocolQALogData,
    createProtocolQAIsSuccess,
    createProtocolQAIsError,
    createProtocolQAError,
    createProtocolQAIsLoading,
    createProtocolQA,
    copyProtocolQAError,
    copyProtocolQAIsError,
    copyProtocolQAIsSuccess,
    copyProtocolQA,
    copyProtocolQAIsLoading
  } = useProtocolQALog();
  const { unSavedWarning } = useFieldTranslation();
  const [submit, setSubmit] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);

  //site level permission //
  const updateSiteProtocolQAPermission = checkPermission('update_site_protocol_qa');
  const updateSiteResponsePermission = checkPermission('update_site_response_protocol_qa');
  const deleteOthersSiteResponsePermission = checkPermission('delete_others_site_protocol_qa');
  const updateOthersSiteProtocolQaPermission = checkPermission('update_others_site_protocol_qa');
  // Sponsor level permission
  const updateSponsorProtocolQAPermission = checkPermission('update_sponsor_protocol_qa');
  const updateSponsorResponsePermission = checkPermission('update_sponsor_response_protocol_qa');
  const deleteOthersSponsorResponsePermission = checkPermission('delete_others_sponsor_protocol_qa');
  const updateOthersSponsorProtocolQaPermission = checkPermission('update_others_sponsor_protocol_qa');

  const [protocolQALogPermissions, setProtocolQALogPermissions] = useState<any>({});
  const copyNewSponserPermission = checkPermission('copy_new_sponsor_question');
  const [selectionModel, setSelectionModel] = React.useState<GridSelectionModel>([]);
  const [selectedNos, setSelectedNos] = useState<any>([]);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [columnVisibilityModelSite, setColumnVisibilityModelSite] = useState({
    id: false,
    isSelected: false
  });
  const currentHierarchyLevel = useAppSelector(state => state.site.currentHierarchyLevel);
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const [columnVisibilityModelSponsor, setColumnVisibilityModelSponsor] = useState({
    id: false,
    isSelected: false
  });

  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [value, setValue] = React.useState<number>(0);
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dataGridShow, setDataGridShow] = useState(false);
  const initialState = {
    created_by: user,
    protocol_qa_level: currentProtocolQALevel,
    study_id: studyId,
    site_id: selectedSite,
    country: selectedCountry,
    application: 'CTMS',
    protocol_qa_assigned_to: [],
    issued_by: user
  };
  const [createData, setCreateData] = useState<any>(initialState);
  const { study_id: studyIdVal, country, site_id: siteIdVal, ...createDataRest } = createData;
  const [updateData, setUpdateData] = useState<any>({
    updated_by: user,
    application: 'CTMS',
    protocol_qa_assigned_to: [],
    id: ''
  });
  const [filterObject, setFilterObject] = useState<any>();

  // deleting the data
  const [deleteData, setDeleteData] = useState<any>({});
  const [openDelete, setOpenDelete] = useState(false);
  const [warningMessage, setWarningMessage] = useState(false);
  const [topic, setTopic] = useState([]);
  const [status, setStatus] = useState([]);
  const { data: topicData } = useGetCodeListDataQuery('SPQTOP');
  const { data: statusData } = useGetCodeListDataQuery('SPQSTA');
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }
  const coordinates = {
    rowIndex: 0,
    colIndex: 0
  };

  const handleTabsChange = (_: React.SyntheticEvent, newValue: number) => {
    setRowsCount(0);
    setPageNumber(0);
    setPageSize(10);
    setValue(newValue);
    setRows([]);
    newValue === 0 ? setProtocolQALevel('SITE') : setProtocolQALevel('SPONSOR');
  };

  const handleClickOpen = () => {
    setEdit(false);
    setCreateData(initialState);
    setOpen(true);
  };

  const handleClose = () => {
    if (warningMessage) {
      setOpenConfirmExit(true);
    } else {
      setSubmit(false);
      setOpen(false);
    }
  };

  // onClick of Add deviation button //
  const handleAddProtocolQAOpen = () => {
    setEdit(false);
    setCreateData(initialState);
    setOpen(true);
  };
  // onClick of edit icon //
  const handelEdit = (data: any) => {
    setUpdateData({ ...data });
    setEdit(true);
    setOpen(true);
  };

  const [
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateOtherResponseProtocol,
    {
      error: updateOtherResponseProtocolQAError,
      isError: updateOtherResponseProtocolQAIsError,
      isLoading: updateOtherResponseProtocolQAIsLoading,
      isSuccess: updateOtherResponseProtocolQAIsSuccess
    }
  ] = useUpdateOtherResponseProtocolQALogMutation();

  const [
    updateResponseProtocol,
    {
      error: updateResponseProtocolQAError,
      isError: updateResponseProtocolQAIsError,
      isSuccess: updateResponseProtocolQAIsSuccess
    }
  ] = useUpdateResponseProtocolQALogMutation();

  const [
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateStatusProtocol,
    {
      error: updateStatusProtocolQAError,
      isError: updateStatusProtocolQAIsError,
      isSuccess: updateStatusProtocolQAIsSuccess
    }
  ] = useUpdateStatusProtocolQALogMutation();

  const [
    updateProtocol,
    {
      error: updateProtocolQAError,
      isError: updateProtocolQAIsError,
      isLoading: updateProtocolQAIsLoading,
      isSuccess: updateProtocolQAIsSuccess
    }
  ] = useUpdateProtocolQALogMutation();

  const [
    updateOthersProtocol,
    {
      error: updateOthersProtocolQAError,
      isError: updateOthersProtocolQAIsError,
      isSuccess: updateOthersProtocolQAIsSuccess
    }
  ] = useUpdateOthersProtocolQALogMutation();

  const [
    deleteProtocolQA,
    {
      error: deleteProtocolQAError,
      isError: deleteProtocolQAIsError,
      isLoading: deleteProtocolQAIsLoading,
      isSuccess: deleteProtocolQAIsSuccess
    }
  ] = useDeleteProtocolQALogMutation();

  const [
    deleteOthersProtocolQA,
    {
      error: deleteOthersProtocolQAError,
      isError: deleteOthersProtocolQAIsError,
      isLoading: deleteOthersProtocolQAIsLoading,
      isSuccess: deleteOthersProtocolQAIsSuccess
    }
  ] = useDeleteOthersProtocolQALogMutation();

  // onClick of delete icon //
  const handleDeleteOpen = (data: any) => {
    setOpenDelete(true);
    setDeleteData({ ...data, application: 'CTMS' });
    // setOpenDelete(true);
  };

  const submitDeleteData = async () => {
    setOpenDelete(false);
    dispatch(showLoader());
    const getDeleteProtocolQA = async () => {
      await deleteProtocolQA({
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry,
        application: 'CTMS',
        id: deleteData.id,
        protocol_qa_level: currentProtocolQALevel
      });
    };
    if (protocolQALogPermissions.update && protocolQALogPermissions.updateOther) {
      getDeleteProtocolQA();
    } else if (protocolQALogPermissions.updateOther) {
      await deleteOthersProtocolQA({
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry,
        application: 'CTMS',
        id: deleteData.id,
        protocol_qa_level: currentProtocolQALevel
      });
    } else if (protocolQALogPermissions.update) {
      getDeleteProtocolQA();
    }
  };

  //Copy Question to sponsor
  const handleOpenCopyToSponsor = async () => {
    dispatch(showLoader());
    const tempSponsorData = await getProtocolQALogData({
      data: { ...filterObject },
      protocol_qa_level: 'SPONSOR',
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME
    });

    if (tempSponsorData?.isSuccess) {
      setRowsCount(tempSponsorData?.data.record_count);
      const sponsorList = tempSponsorData.data.selected_data.map(
        (item: any) => item.protocol_qa_details.cloned_protocol_qa_no
      );
      const copiedNos = selectedNos.filter((item: any) => sponsorList.includes(item));
      const remainingNos = selectedNos.filter((item: any) => !sponsorList.includes(item));

      if (remainingNos.length === 0) {
        dispatch(
          setMessage({
            msgDetails: 'Selected question(s) already copied to Sponsor.',
            severity: 'error'
          })
        );
        setConfirmOpen(false);
      } else {
        setConfirmOpen(true);
        if (copiedNos.length !== 0) {
          dispatch(
            setMessage({
              msgDetails: 'Some of the selected question(s) are already copied to Sponsor',
              severity: 'error'
            })
          );
        }
        setSelectedNos(remainingNos);
      }
    } else if (tempSponsorData?.isError) {
      setRowsCount(0);
      setPageNumber(0);
      setSelectedNos(selectedNos);
      setConfirmOpen(true);
    }
    dispatch(hideLoader());
  };

  useEffect(() => {
    if (archLevel == 'site' && archLevel != 'sponsor' && checkPermission('view_site_protocol_qa')) {
      setProtocolQALevel('SITE');
    } else if (archLevel == 'sponsor' && archLevel != 'site' && checkPermission('view_site_protocol_qa')) {
      setProtocolQALevel('SITE');
    } else if (archLevel == 'sponsor' && archLevel != 'site' && checkPermission('view_sponsor_protocol_qa')) {
      setProtocolQALevel('SPONSOR');
    }
  }, []);

  useEffect(() => {
    if (value === 0 && currentProtocolQALevel === 'SITE') {
      setProtocolQALogPermissions({
        update: updateSiteProtocolQAPermission,
        updateOther: updateOthersSiteProtocolQaPermission,
        updateResponse: updateSiteResponsePermission,
        deleteOther: deleteOthersSiteResponsePermission
      });
    } else {
      setProtocolQALogPermissions({
        update: updateSponsorProtocolQAPermission,
        updateOther: updateOthersSponsorProtocolQaPermission,
        updateResponse: updateSponsorResponsePermission,
        deleteOther: deleteOthersSponsorResponsePermission
      });
    }
  }, [value, currentProtocolQALevel]);

  useEffect(() => {
    if (
      createProtocolQAIsLoading ||
      deleteProtocolQAIsLoading ||
      deleteOthersProtocolQAIsLoading ||
      copyProtocolQAIsLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    createProtocolQAIsLoading,
    deleteProtocolQAIsLoading,
    updateOtherResponseProtocolQAIsLoading,
    updateProtocolQAIsLoading,
    deleteOthersProtocolQAIsLoading,
    copyProtocolQAIsLoading
  ]);

  const getProtocolQALog = async (from: number, size: number) => {
    if (currentProtocolQALevel == '') {
      return;
    }
    setDataGridShow(true);
    const tempQaLog = await getProtocolQALogData({
      data: { ...filterObject },
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      protocol_qa_level: currentProtocolQALevel,
      application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME,
      from,
      size
    });

    const tempRows: any = [];
    if (tempQaLog.isSuccess) {
      setRowsCount(tempQaLog?.data.record_count);
      tempQaLog.data.selected_data &&
        tempQaLog.data.selected_data.length > 0 &&
        tempQaLog?.data.selected_data.map((protocolQAData: any) => {
          tempRows.push({
            id: protocolQAData.protocol_qa_details.id,
            qa_no: protocolQAData.protocol_qa_details.qa_no,
            issued_by: protocolQAData.protocol_qa_details.issued_by,
            topic: protocolQAData.protocol_qa_details.topic,
            description: protocolQAData.protocol_qa_details.description,
            study_id: protocolQAData.study_id,
            site_id: protocolQAData.site_id,
            country: protocolQAData.country,
            summary: protocolQAData.protocol_qa_details.summary,
            status: protocolQAData.protocol_qa_details.status,
            response: protocolQAData.protocol_qa_details.response,
            response_dt: protocolQAData.protocol_qa_details.response_dt,
            protocol_qa_assigned_to: protocolQAData.protocol_qa_assigned_to
          });
        });
      if (tempRows.length > 0) {
        setRows(tempRows);
        if (apiRef) {
          const { rowIndex, colIndex } = coordinates;
          apiRef.current.scrollToIndexes(coordinates);
          const id = gridVisibleSortedRowIdsSelector(apiRef)[rowIndex];
          const column = gridVisibleColumnDefinitionsSelector(apiRef)[colIndex];
          column && apiRef.current.setCellFocus(id, column.field);
        }
      }
    } else if (tempQaLog?.isError) {
      setRowsCount(0);
      setPageNumber(0);
      setRows([]);
    }
    setDataGridShow(false);
  };

  useEffect(() => {
    if (topicData) {
      setTopic(topicData);
    }
  }, [topicData]);
  useEffect(() => {
    if (statusData) {
      setStatus(statusData);
    }
  }, [statusData]);

  // Calling siteStudyPersonnel api on hierarchy level change
  useEffect(() => {
    if (currentProtocolQALevel == '') {
      return;
    }
    getProtocolQALog(pageNumber * pageSize, pageSize);
  }, [currentHierarchyLevel, studyId, selectedCountry, selectedSite, value, currentProtocolQALevel]);

  useEffect(() => {
    if (!protocolQALogDataIsLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getProtocolQALog(0, pageSize);
      } else {
        getProtocolQALog(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize, filterObject]);

  useEffect(() => {
    if (protocolQALogData) {
      if (!checkPermission('view_site_protocol_qa') && !checkPermission('view_sponsor_protocol_qa')) {
        setRows([]);
      }
    }
  }, [
    protocolQALogDataIsError,
    isHierarchyLevelClosed,
    protocolQALogDataIsLoading,
    selectedSite,
    value,
    currentHierarchyLevel
  ]);

  useEffect(() => {
    if (protocolQALogDataIsError) {
      const err: any = protocolQALogDataError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    setDataGridShow(false);
  }, [protocolQALogDataIsError, protocolQALogDataError]);

  useEffect(() => {
    setRows([]);
  }, [currentProtocolQALevel, currentHierarchyLevel]);
  const buttonRef = useRef<any>();
  let createRequestObj = {};
  let updateRequestObj = {};

  // onClick of save button in add and edit question popup //
  const handleSave = async () => {
    dispatch(showLoader());
    buttonRef.current.setAttribute('disabled', 'disabled');
    setDisableSubmit(true);
    setWarningMessage(false);
    setSubmit(true);
    const getUpdateProtocolQA = async () => {
      if (updateRequestObj !== updateData) {
        updateRequestObj = updateData;
        const date = new Date();
        await updateProtocol({
          study_id: studyId,
          site_id: selectedSite,
          country: selectedCountry,
          application: 'CTMS',
          id: updateData.id,
          protocol_qa_level: currentProtocolQALevel,
          data: {
            issued_by: updateData?.issued_by,
            topic: updateData?.topic,
            summary: updateData?.summary,
            description: updateData?.description,
            response: updateData?.response,
            response_dt: date.toISOString().split('T')[0],
            status: updateData?.status,
            protocol_qa_level: updateData?.protocol_qa_level,
            cloned_protocol_qa_no: updateData?.cloned_protocol_qa_no,
            protocol_qa_assigned_to: [
              updateData?.protocol_qa_assigned_to === null
                ? ''
                : Array.isArray(updateData?.protocol_qa_assigned_to)
                ? updateData?.protocol_qa_assigned_to[0]
                : updateData?.protocol_qa_assigned_to
            ],
            updated_by: user
          }
        });
      }
    };

    if (edit) {
      if (protocolQALogPermissions.update && protocolQALogPermissions.updateOther) {
        getUpdateProtocolQA();
      } else if (protocolQALogPermissions.updateOther) {
        if (updateRequestObj !== updateData) {
          updateRequestObj = updateData;
          const date = new Date();
          await updateOthersProtocol({
            study_id: studyId,
            site_id: selectedSite,
            country: selectedCountry,
            application: 'CTMS',
            id: updateData.id,
            protocol_qa_level: currentProtocolQALevel,
            data: {
              issued_by: updateData?.issued_by,
              topic: updateData?.topic,
              summary: updateData?.summary,
              description: updateData?.description,
              response: updateData?.response,
              response_dt: date.toISOString().split('T')[0],
              status: updateData?.status,
              protocol_qa_level: updateData?.protocol_qa_level,
              cloned_protocol_qa_no: updateData?.cloned_protocol_qa_no,
              protocol_qa_assigned_to: [
                updateData?.protocol_qa_assigned_to === null
                  ? ''
                  : Array.isArray(updateData?.protocol_qa_assigned_to)
                  ? updateData?.protocol_qa_assigned_to[0]
                  : updateData?.protocol_qa_assigned_to
              ],
              updated_by: user
            }
          });
        }
      } else if (protocolQALogPermissions.update) {
        getUpdateProtocolQA();
      }
      if (protocolQALogPermissions.updateResponse) {
        if (updateRequestObj !== updateData) {
          updateRequestObj = updateData;
          const date = new Date();
          await updateResponseProtocol({
            study_id: studyId,
            site_id: selectedSite,
            country: selectedCountry,
            application: 'CTMS',
            id: updateData.id,
            protocol_qa_level: currentProtocolQALevel,
            data: {
              response: updateData?.response,
              response_dt: date.toISOString().split('T')[0]
            }
          });
        }
      }
    } else {
      if (createRequestObj !== createDataRest && createData.study_id !== null) {
        const date = new Date();
        createRequestObj = { ...createDataRest, response_dt: date.toISOString().split('T')[0] };
        await createProtocolQA({
          data: createRequestObj,
          protocol_qa_level: currentProtocolQALevel,
          study_id: createData.study_id,
          country: createData.country,
          site_id: createData.site_id
        });
      }
    }
    dispatch(hideLoader());
  };

  useEffect(() => {
    setDisableSubmit(false);
    if (createProtocolQAIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: 'Protocol Q&A created successfully',
          severity: 'success'
        })
      );
      getProtocolQALog(0, 10);
    }
    if (createProtocolQAIsError) {
      const err: any = createProtocolQAError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    dispatch(hideLoader());
  }, [createProtocolQAIsSuccess, createProtocolQAIsError, createProtocolQAError]);

  useEffect(() => {
    setDisableSubmit(false);
    if (deleteProtocolQAIsSuccess || deleteOthersProtocolQAIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: `Protocol Q&A log deleted successfully`,
          severity: 'success'
        })
      );
      getProtocolQALog(0, 10);
    }
    if (deleteProtocolQAIsError || deleteOthersProtocolQAIsError) {
      const err: any = deleteProtocolQAError || deleteOthersProtocolQAError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    dispatch(hideLoader());
  }, [
    deleteProtocolQAIsSuccess,
    deleteOthersProtocolQAIsSuccess,
    deleteOthersProtocolQA,
    deleteProtocolQAIsError,
    deleteOthersProtocolQAIsError,
    deleteProtocolQAError,
    deleteOthersProtocolQAError
  ]);

  useEffect(() => {
    setDisableSubmit(false);
    if (updateProtocolQAIsSuccess || updateOthersProtocolQAIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: `Protocol Q&A log updated successfully`,
          severity: 'success'
        })
      );
      getProtocolQALog(pageNumber * pageSize, pageSize);
    }
    if (updateProtocolQAIsError || updateOthersProtocolQAIsError) {
      const err: any = updateProtocolQAError || updateOthersProtocolQAError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    dispatch(hideLoader());
  }, [
    updateProtocolQAIsSuccess,
    updateOthersProtocolQAIsSuccess,
    updateProtocolQAIsError,
    updateOthersProtocolQAIsError,
    updateProtocolQAError,
    updateOthersProtocolQAError
  ]);

  useEffect(() => {
    setDisableSubmit(false);
    if (updateStatusProtocolQAIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: `Protocol Q&A log updated successfully`,
          severity: 'success'
        })
      );
      getProtocolQALog(pageNumber * pageSize, pageSize);
    }
    if (updateStatusProtocolQAIsError) {
      const err: any = updateStatusProtocolQAError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    dispatch(hideLoader());
  }, [updateStatusProtocolQAIsSuccess, updateStatusProtocolQAIsError, updateStatusProtocolQAError]);

  useEffect(() => {
    setDisableSubmit(false);
    if (updateResponseProtocolQAIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: `Protocol Q&A log updated successfully`,
          severity: 'success'
        })
      );
      getProtocolQALog(pageNumber * pageSize, pageSize);
    }
    if (updateResponseProtocolQAIsError) {
      const err: any = updateResponseProtocolQAError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    dispatch(hideLoader());
  }, [updateResponseProtocolQAIsSuccess, updateResponseProtocolQAIsError, updateResponseProtocolQAError]);

  useEffect(() => {
    setDisableSubmit(false);
    if (updateOtherResponseProtocolQAIsSuccess) {
      setOpen(false);
      setSubmit(false);
      dispatch(
        setMessage({
          msgDetails: `Protocol Q&A log updated successfully`,
          severity: 'success'
        })
      );
      getProtocolQALog(pageNumber * pageSize, pageSize);
    }
    if (updateOtherResponseProtocolQAIsError) {
      const err: any = updateOtherResponseProtocolQAError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
    dispatch(hideLoader());
  }, [
    updateOtherResponseProtocolQAIsSuccess,
    updateOtherResponseProtocolQAIsError,
    updateOtherResponseProtocolQAError
  ]);

  const handleCloseCopyToSponsor = () => {
    setConfirmOpen(false);
  };

  const handleConfirmCopyToSponsor = async () => {
    await copyProtocolQA({
      study_id: studyId,
      site_id: selectedSite,
      country: selectedCountry,
      application: 'CTMS',
      data: { protocol_qa_no_list: selectedNos }
    });
  };

  useEffect(() => {
    if (copyProtocolQAIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'Protocol Q&A created successfully',
          severity: 'success'
        })
      );
      setProtocolQALevel('SPONSOR');
      setValue(1);
      setDataGridShow(true);
      setSelectionModel([]);
      setConfirmOpen(false);
    } else if (copyProtocolQAIsError) {
      const errorCopy: any = copyProtocolQAError;
      if (errorCopy?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${errorCopy?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorCopy?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (errorCopy?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error in copy to sponsor question(s)',
            severity: 'error'
          })
        );
      }
    }
  }, [copyProtocolQAIsSuccess, copyProtocolQAIsError]);

  // for Custom buttons at bottom in Data Grid
  function CustomFooterButtons() {
    return (
      <GridFooterContainer>
        <Box sx={{ p: 1, display: 'flex', columnGap: 1 }}>
          {protocolQALogPermissions.update ? (
            <Button
              disabled={
                !((currentProtocolQALevel == 'SITE' && selectedSite != null) || currentProtocolQALevel !== 'SITE')
              }
              startIcon={<AddIcon />}
              onClick={handleAddProtocolQAOpen}
            >
              ADD QUESTION
            </Button>
          ) : null}

          {currentProtocolQALevel == 'SITE' && copyNewSponserPermission && selectedSite !== null ? (
            <Button
              variant="contained"
              disabled={selectionModel.length === 0 ? true : false}
              onClick={handleOpenCopyToSponsor}
              sx={{ letterSpacing: '-0.25px', padding: '6px 8px' }}
            >
              COPY AS NEW SPONSOR QUESTION
            </Button>
          ) : null}
        </Box>
        <GridFooter />
      </GridFooterContainer>
    );
  }

  // checkbox selection
  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const rowSelected = rows
      .filter((row: any) => selectedIds.has(row.id))
      .map((elem: any) => elem.qa_no)
      .sort();
    setSelectedNos(rowSelected);
  };

  return (
    <div>
      <Loader />
      <Box className="mainBackBtnWrap">
        <Button startIcon={<ArrowBackIcon fontSize="small" />} onClick={handelBack}>
          List of Logs
        </Button>
      </Box>
      <Grid container spacing={2} alignItems="center" className="titleGrid">
        <Grid item xs>
          <Typography variant="h6" component="h6">
            Protocol Q&A
          </Typography>
        </Grid>
        <Grid item sx={{ textAlign: 'right' }}>
          <Button variant="contained" style={{ textTransform: 'none' }}>
            {value ? 'PUBLISH TO eTMF' : 'PUBLISH TO eISF'}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ width: '100%' }}>
        {archLevel == 'site' && archLevel != 'sponsor' && checkPermission('view_site_protocol_qa') ? (
          <Tabs
            value={value}
            onChange={handleTabsChange}
            aria-label="Subject Tracking Tabs"
            className="tabsFontSize extendedTabs"
          >
            <Tab label="Site" {...a11yProps(0)} />
          </Tabs>
        ) : (
          ''
        )}
        {archLevel == 'sponsor' && archLevel != 'site' ? (
          <Tabs
            value={value}
            onChange={handleTabsChange}
            aria-label="Subject Tracking Tabs"
            className="tabsFontSize extendedTabs"
          >
            {checkPermission('view_site_protocol_qa') && <Tab label="Site" {...a11yProps(0)} />}
            {checkPermission('view_sponsor_protocol_qa') && <Tab label="Sponsor" {...a11yProps(1)} />}
          </Tabs>
        ) : (
          ''
        )}
        <DataGridProtocolQALog
          rows={rows}
          rowsCount={rowsCount}
          page={pageNumber}
          pageSize={pageSize}
          setPageSize={setPageSize}
          apiRef={apiRef}
          handleClickOpen={handleClickOpen}
          handleDeleteOpen={handleDeleteOpen}
          handelEdit={handelEdit}
          CustomFooterButtons={CustomFooterButtons}
          protocolQALogPermissions={protocolQALogPermissions}
          currentProtocolQALevel={currentProtocolQALevel}
          isLoading={dataGridShow}
          checkboxSelection={
            selectedSite !== null
              ? copyNewSponserPermission && currentProtocolQALevel === 'SITE'
                ? true
                : false
              : false
          }
          checkboxSelectionVisibleOnly
          selectionModel={selectionModel}
          onSelectionModelChange={(newValue: any) => onSelectionModelChange(newValue)}
          columnVisibilityModel={
            currentProtocolQALevel === 'SITE' ? columnVisibilityModelSite : columnVisibilityModelSponsor
          }
          setColumnVisibilityModel={
            currentProtocolQALevel === 'SITE' ? setColumnVisibilityModelSite : setColumnVisibilityModelSponsor
          }
          topic={topic}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          setFilterObject={setFilterObject}
        />
      </Box>
      <PopupComponent aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
        <Loader />
        <DialogTitle>{edit ? 'Edit' : 'Add'} Question</DialogTitle>
        <DialogContent className="modal800">
          <AddandUpdateProtocolQA
            createData={createData}
            setCreateData={setCreateData}
            edit={edit}
            updateData={updateData}
            setUpdateData={setUpdateData}
            initialState={initialState}
            submit={submit}
            // componentRef={componentRef}
            // error={error}
            topic={topic}
            status={status}
            currentProtocolQALevel={currentProtocolQALevel}
            protocolQALogPermissions={protocolQALogPermissions}
            setDisableSubmit={setDisableSubmit}
            selectedSite={selectedSite}
            setWarningMessage={setWarningMessage}
          />
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleSave} ref={buttonRef} disabled={disableSubmit}>
            Save
          </Button>
        </DialogActions>
      </PopupComponent>
      <div>
        <PopupComponent
          open={openDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the question - {deleteData.qa_no}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenDelete(false);
              }}
              className="grey-btn"
            >
              CANCEL
            </Button>
            <Button
              onClick={() => {
                submitDeleteData();
              }}
            >
              DELETE
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child
        >
          <DialogTitle id="alert-dialog-title">
            <b>Confirm Exit</b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              CLOSE
            </Button>
            <Button
              onClick={() => {
                setOpen(false);
                setOpenConfirmExit(false);
              }}
            >
              OK
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
      <div>
        <PopupComponent open={confirmOpen} onClose={handleCloseCopyToSponsor} className="smallDialogs">
          <Loader />
          <DialogTitle>Confirm</DialogTitle>
          <DialogContent className="tsda_prescreenDialog">
            <DialogContentText>
              <Typography my={1} sx={{ color: 'rgba(0,0,0,0.87)' }}>
                Would you like to copy the following Protocol question(s) to sponsor questions?
              </Typography>
            </DialogContentText>

            <Paper sx={{ width: '100%', height: '200px', bgcolor: 'background.paper', overflowY: 'auto', mb: -2 }}>
              <List dense component="nav">
                {selectedNos.map((id: any, i: number) => (
                  <ListItem key={i} disablePadding>
                    <ListItemText primary={id} sx={{ padding: '5px', paddingLeft: '13px' }} />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button className="grey-btn" onClick={handleCloseCopyToSponsor}>
              Cancel
            </Button>
            <Button onClick={handleConfirmCopyToSponsor} disabled={selectedNos.length === 0}>
              Confirm
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
    </div>
  );
}
